import { NocApplyForm } from '../../components/noc-apply-form/noc-apply-form';

export const NocApplyPage = () => <NocApplyForm />;
